import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useParams } from "react-router-dom";
import Form  from '../common/Form';
import { post } from '../../utils/api';

const Restore = () => {
	const { t, i18n } = useTranslation();
	const lang = i18n.language;
	const params = useParams();
	const [ email, setEmail ] = useState(params.email ? params.email : '');
	const [ isLoading, setIsLoading ] = useState(false);
	const [ error, setError ] = useState('');
	const [ success, setSuccess ] = useState('');

	const onSubmit = async () => {
		setIsLoading(true);
        setError('');
		setSuccess('');
		const result = await post('/restore', { email, lang });
		if(result.error) {
			setError(result.error);
		} else {
			setSuccess('restore.success');
		}
        setIsLoading(false);
	};

	return (
		<div>
	    	<h1>{t('restore.title')}</h1>			
			{isLoading ? <div>{t('common.loading')}</div> :
			<React.Fragment>
				{success ? <p>{t(success)}</p> :
				<Form error={t(error)} info={t('restore.subtitle')}>
					<label htmlFor='email'>{t('restore.email')}</label>
					<input
						id='email'
						type='text'
						value={email}
						onChange={e => setEmail(e.target.value)}
					/>
					<input
						id='submit'
						type='submit'
						value={t('restore.submit')}
						disabled={email ? false : true}
						onClick={onSubmit}
					/>
				</Form>}
				<NavLink to={email ? '/cabinet/newpass/email/' + email : '/cabinet/newpass'}>{t('restore.code')}</NavLink><br/>
				<NavLink to={email ? '/cabinet/login/email/' + email : '/cabinet/login'}>{t('restore.login')}</NavLink>
			</React.Fragment>}
		</div>
	);
};

export default Restore;
